interface Props {
  fillColor?: string;
}

export const CardIcon = ({ fillColor = '#2C213C' }: Props) => (
  <svg
    data-testid="card-icon-svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 2.5H2.5C1.80625 2.5 1.25625 3.05625 1.25625 3.75L1.25 11.25C1.25 11.9437 1.80625 12.5 2.5 12.5H12.5C13.1938 12.5 13.75 11.9437 13.75 11.25V3.75C13.75 3.05625 13.1938 2.5 12.5 2.5ZM12.5 11.25H2.5V7.5H12.5V11.25ZM12.5 5H2.5V3.75H12.5V5Z"
      fill={fillColor}
    />
  </svg>
);

export const CrownIcon = ({ fillColor = '#2C213C' }: Props) => (
  <svg
    data-testid="crown-icon-svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.01447 10.0481C2.87212 10.0481 2.75288 9.99983 2.65675 9.90337C2.56062 9.8069 2.51239 9.68766 2.51206 9.54565C2.51172 9.40363 2.55995 9.28439 2.65675 9.18793C2.75355 9.09147 2.87279 9.04324 3.01447 9.04324H9.04343C9.18578 9.04324 9.30518 9.09147 9.40164 9.18793C9.49811 9.28439 9.54617 9.40363 9.54583 9.54565C9.5455 9.68766 9.49727 9.80707 9.40114 9.90387C9.30501 10.0007 9.18578 10.0487 9.04343 10.0481H3.01447ZM3.36574 8.03841C3.1229 8.03841 2.90737 7.95886 2.71913 7.79976C2.53089 7.64066 2.41567 7.4397 2.37347 7.19687L1.87106 4.00654C1.85431 4.00654 1.83555 4.00872 1.81479 4.01307C1.79402 4.01743 1.7751 4.01944 1.75802 4.0191C1.54868 4.0191 1.37082 3.94592 1.22445 3.79955C1.07808 3.65318 1.00473 3.47516 1.0044 3.26548C1.00406 3.05581 1.07741 2.87796 1.22445 2.73192C1.37149 2.58589 1.54935 2.51253 1.75802 2.51186C1.96668 2.51119 2.14471 2.58455 2.29208 2.73192C2.43945 2.8793 2.51264 3.05715 2.51163 3.26548C2.51163 3.3241 2.50527 3.37853 2.49254 3.42877C2.47982 3.47901 2.46525 3.52506 2.44883 3.56693L4.01887 4.27031L5.58891 2.12249C5.4968 2.05551 5.42144 1.96758 5.36283 1.85873C5.30421 1.74987 5.27491 1.63264 5.27491 1.50704C5.27491 1.2977 5.34826 1.11968 5.49496 0.972973C5.64167 0.826268 5.81952 0.753083 6.02853 0.753418C6.23753 0.753753 6.41555 0.827106 6.56259 0.973475C6.70963 1.11984 6.78281 1.2977 6.78214 1.50704C6.78214 1.63264 6.75284 1.74987 6.69422 1.85873C6.63561 1.96758 6.56025 2.05551 6.46814 2.12249L8.03818 4.27031L9.60822 3.56693C9.59147 3.52506 9.57673 3.47901 9.56401 3.42877C9.55128 3.37853 9.54508 3.3241 9.54542 3.26548C9.54542 3.05614 9.61877 2.87812 9.76547 2.73142C9.91218 2.58471 10.09 2.51153 10.299 2.51186C10.508 2.5122 10.6861 2.58555 10.8331 2.73192C10.9801 2.87829 11.0533 3.05614 11.0527 3.26548C11.052 3.47482 10.9788 3.65284 10.8331 3.79955C10.6874 3.94625 10.5094 4.01944 10.299 4.0191C10.2823 4.0191 10.2635 4.01709 10.2428 4.01307C10.222 4.00905 10.2031 4.00688 10.186 4.00654L9.68358 7.19687C9.64171 7.4397 9.52666 7.64066 9.33842 7.79976C9.15018 7.95886 8.93448 8.03841 8.69131 8.03841H3.36574Z"
      fill={fillColor}
    />
  </svg>
);
